<template>
	<db-col class="text-wrapper" @click="clickHandler" :class="['text-wrapper-' + disabled, simple ? 'text-wrapper-simple' : '']" :height="height" :width="width" valign="middle">
		<db-icon width="auto" class="prefix-icon" :icon="prefixIcon" v-if="prefixIcon" />
		<input :_readonly="readonly" autocomplete="off" @click="iptClickHandler" @focus="focusHandler" @blur="blurHandler" :type="textType" ref="input" class="ipt-case auto-fill" :class="inputClass" :value="inputValue" :disabled="disabled" :placeholder="placeholder" @input="inputHandler" :maxLength="maxlength" :style="iptStyle" />
		<db-icon icon="cancel" size="36" class="disabled-icon" v-if="disabled" />
		<db-icon width="auto" class="prefix-icon" @click="eyeHandler" :icon="eye ? 'eye' : 'uneye'" v-if="!disabled && value !== '' && type.toLowerCase() === 'password'" />
		<db-icon width="auto" class="close-icon" icon="close-o" v-if="!disabled && close && (!readonly) && (value !== '')" @click="clear" />
		<error-show v-model="errorMessage" :align="align" />
	</db-col>
</template>

<script>
	import Code from '../../../../model/Code'
	import {Picker} from '../../../../model/Dialog'
	import DatePicker from '../../../../model/DatePicker'
	import {TextAlignTypes} from '../../../../enum'
	import ErrorShow from '../error/Index'
	
	export default {
		name: 'text_',
		
		components: {
			ErrorShow
		},
		
		props: {
			height: {
				type: [String, Number],
				default: '88'
			},
			
			width: {
				type: [String, Number],
				default: '100%'
			},
			
			type: {
				type: String,
				default: 'text'
			},
			
			value: {
				type: [String, Number],
				default: ''
			},
			
			placeholder: {
				type: String,
				default: ''
			},
			
			prefixIcon: {
				type: String,
				default: ''
			},
			
			maxlength: {
				type: [String, Number],
				default: '-1'
			},
			
			close: {
				type: Boolean,
				default: false
			},
			
			readonly: {
				type: Boolean,
				default: false
			},
			
			simple: {
				type: Boolean,
				default: false
			},
			
			disabled: {
				type: Boolean,
				default: false
			},
			
			fetch: {
				type: [Function, Array, Promise, Object]
			},
			
			fetchText: {
				type: String,
				default: ''
			},
			
			align: {
				type: String,
				default: TextAlignTypes.RIGHT
			}
		},
		
		data(){
			return {
				iptStyle: {
					opacity: 0,
					textAlign: this.align
				},
				eye: false,
				text: '',
				inputValue: this.value,
				errorMessage: ''
			}
		},
		
		mounted(){
			this.watchHandler(this.value)
			if(this.type.toLowerCase() === "password"){
				setTimeout(() => {
					this.$refs.input.setAttribute('type', 'password')
					this.iptStyle.opacity = 1.0
				}, 600)
			}else{
				this.iptStyle.opacity = 1.0
			}
			this.$refs.input.onblur = function(){}
			this.iptStyle.textAlign = this.align
			if(this.readonly || this.shouldReadonly || this.type.toLowerCase() === "money"){
				this.$refs.input.setAttribute('readonly', 'readonly')
			}
		},
		
		watch: {
			readonly(val){
				if(!this.shouldReadonly){
					if(val){
						this.$refs.input.setAttribute('readonly', 'readonly')
					}else{
						this.$refs.input.removeAttribute('readonly')
					}
				}
			},
			
			/* 监视value变化、text组件显示的是映射值(因为各个picker展示的值不一定就是value值) */
			value(val){
				this.watchHandler(val)
			}
		},
		
		computed: {
			shouldReadonly(){
				const type = this.type.toUpperCase()
				return this.fetch || ['DATE', 'TIME'].includes(type)
			},
			
			inputClass(){
				const styleDisabled = 'ipt-disabled-' + this.disabled
				const styleSimple = 'ipt-simple-' + this.simple
				return [styleDisabled, styleSimple, 'ipt-align-' + this.align.toLowerCase()]
			},
			
			textType(){
				const type = this.type.toUpperCase()
				if(type === 'PASSWORD'){
					return this.eye ? 'text' : 'password'
				}else{
					if(['DATE', 'TIME', 'MONEY'].includes(type)){
						return 'text'
					}
					return this.type
				}
			}
		},

		methods: {
			iptClickHandler(){
				//window._activeElement = event.target || event.srcElement
			},
			
			watchHandler(val){
				if(this.fetch){
					if(this.fetch instanceof Promise){
						this.inputValue = this.fetchText
					}else{
						const columns = this.fetch.props.columns
						if(columns){
							if(typeof columns[0][0] === 'object'){
								if(this.type != 'date'){
									/* 这里不要求一定要是 Code类型，自己建对象也行 */
									const texts = [], values = this.value.split(',')
									columns.forEach((column, idx) => {
										for(let i = 0; i < column.length; i ++){
											if(column[i].code == values[idx]){
												texts.push(column[i].text)
												break
											}
										}
									})
									this.inputValue = texts.join('、')
								}else{
									this.inputValue = val
								}
							}
						}else{
							this.inputValue = val
						}
					}
				}else{
					this.inputValue = val
				}
			},
			
			setErrorMessage(errorMessage){
				this.errorMessage = errorMessage
			},
			
			clearErrorMessage(){
				this.errorMessage = ''
			},
			
			inputHandler(){
				this.$emit('input', event.target.value)
			},
			
			focusHandler(){
				if(this.readonly || this.shouldReadonly){
					event.target.blur()
					return false
				}else{ 
					this.$refs.input.focus()
					this.$emit('focusHandler')
					this.errorMessage = ''
				}
			},
			
			blurHandler(){
			},
			
			clear(){
				event.stopPropagation()
				this.clearErrorMessage()
				this.$emit('input', '')
			},
			
			eyeHandler(){
				this.eye = !this.eye
			},
			
			async clickHandler(){
				//event.stopPropagation()
				if(this.type.toUpperCase() !== 'MONEY'){
					if(this.fetch){
						const props = this.fetch
						props.props.value = this.value
						
						if(props.type === 'normal'){
							props.handler = value => {
								this.$emit('input', value.codes)
							}
							this.$picker(props)
						}else if(props.type === 'datePicker'){
							props.handler = value => {
								this.$emit('input', props.getValue(value.codes))
							}
							this.$datePicker(props)
						}
					}
				}else{
					this.$keyboard()
				}
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.text-wrapper{
		position: relative;
		border: solid 1px #dedede;
		border-radius: 8px;
		box-shadow: 0 0 16px rgba(#000, .1);
		padding: 0 18px;
		transition: border .3s;
		
		&:hover{
			border-color: #3B9FFF;
			box-shadow: 0 0 16px rgba(#3B9FFF, .4);
		}
		
		&.text-wrapper-simple{
			border: none;
			box-shadow: none;
		}
		
		&.text-wrapper-true{
			background: #f0f0f0;
			
			&:hover{
				border-color: #dedede;
				box-shadow: 0 0 16px rgba(#000, .1);
			}
		}
		
		.prefix-icon{
			margin: 0 0 0 8px;
			color: #999;
			font-size: 36px;
		}
		
		.disabled-icon{
			color: #ccc;
			//font-weight: bold;
		}
		
		.close-icon{
			margin: 0 0 0 8px;
			color: #ccc;
			font-size: 32px;
		}
	}
	
	.ipt-case{
		//padding: 0 16px;
		color: #333;
		background: transparent;
		font-size: 28px;
		line-height: 28px;
		user-select: text;
		//caret-color: transparent;
		
		&.ipt-disabled-true{
			color: #999;
			font-style: italic;
		}
		
		&.ipt-simple-true{
			text-align: right;
		}
		
		&.ipt-align-left{
			text-align: left;
			
			&::-webkit-input-placeholder{
				color: #C0C4CC;
				font-weight: normal;
				text-align: left;
				line-height: 1;
			}
		}
		
		&.ipt-align-right{
			text-align: right;
			
			&::-webkit-input-placeholder{
				color: #C0C4CC;
				font-weight: normal;
				text-align: right;
				line-height: normal;
			}
		}
	}
</style>
